<template>
  <div class="routerView">
    <mheader ref="mheader"></mheader>
    <div class="mat"></div>
    <div class="page-container">
      <div class="page-content">
        <sidebar></sidebar>
        <router-view class="content-wrapper clearfix"></router-view>
      </div>
    </div>
  </div>
</template>

<script>
  import mheader from "components/header"
  import sidebar from "components/sidebar"

  export default {
    name: "",
    mounted () {},
    components: {
      mheader,
      sidebar
    }
  }
</script>

<style lang="scss" type="text/scss">
  @media screen and (min-width: 769px) {
    .routerView{
      .page-container{
        .sidebar{
          position: fixed;
          top: 48px;
          bottom: 0;
        }
        .content-wrapper{
          padding-left: 260px;
          box-sizing: border-box;
        }
        
      .outer:after {clear:both;content:'.';display:block;width: 0;height: 0;visibility:hidden;}
      }
      .mat{
        height: 48px;
      }
    }
  }
  
</style>



// WEBPACK FOOTER //
// spView.vue?60339388